import React from "react";
import { CloseButton } from "../../../../components/styled/BasicBlocks";
import "./SideMenuCommon.css";

export const SideMenuCommonHeader = ({text, onClose}: {text: React.ReactNode, onClose: ()=>void})=>{
    const handleClose = ()=>{
        onClose();
    }

    return (
        <div className="SideMenuCommonHeader">
            <div className="SideMenuCommonHeader_title">{text}</div>
            <CloseButton onClick={handleClose}></CloseButton>
        </div>
    )
}